import React, {useContext} from 'react';
import {InsuranceContext} from "../InsuranceContext";
import TitleInsurance from "../TitleInsurance";
import InsuranceInput from "../InsuranceInput";
import InsuranceInputHolder from "../InsuranceInput/InsuranceInputHolder";
import {optionArray} from "../functions";

function FinancialInformation(props) {
  const helper = useContext(InsuranceContext);
  const setMyData = helper.setMyData
  const myData = helper.myData


  const objectKey = 'financial'


  const afterRLookUpFound = (response) => {
    const sendData = {...myData.sendData}
    sendData[objectKey]['fundId'] = response['na_97'] ? response['na_97'] : ""
    sendData[objectKey]['fundName'] = response['na_98'] ? response['na_98'] : ""
    setMyData({sendData})
  }
  const afterRLookUpBank = (response) => {
    const sendData = {...myData.sendData}
    sendData[objectKey]['bankId'] = response['na_99'] ? response['na_99'] : ""
    sendData[objectKey]['bankName'] = response['na_101'] ? response['na_101'] : ""
    setMyData({sendData})
  }

  const afterSelectAgentRLookUpId=(response)=>{
    const sendData = {...myData.sendData}
    sendData[objectKey]['agentId'] = response['na_88'] ? response['na_88'] : ""
    sendData[objectKey]['agentName'] = response['na_89'] ? response['na_101'] : ""
    setMyData({sendData})
  }

  const hasAgentOptions = optionArray(myData?.selectBoxData?.hasAgent)
  const receiveTypeOptions = optionArray(myData?.selectBoxData?.receiveType)

const varRLookUp =(myData.sendData[objectKey].depAgentRLookup)
  console.log(varRLookUp)
  return (<div>
    <TitleInsurance title={'مالی'}/>
    <div className={'insurance__box border__insurance'}>
      <InsuranceInputHolder
        objectKey={objectKey}
        row={//
          {
            title: "آیا نماینده دارد؟", type: 'selectBox',

            name: 'hasAgent', required: true, options: hasAgentOptions,//
          }}
      />
      {myData.sendData[objectKey].hasAgent === "دارد" &&
        <InsuranceInputHolder
          functionAfterSelect={afterSelectAgentRLookUpId}


          objectKey={objectKey}
        row={//
          {
            title: "کد نماینده", name: 'agentId', type: 'rlookup', rlookupId: myData?.initialData?.agentRLookUpId,//
            required: false,//
            conditionFields:"yes" //
          }}
          // وقتی داریم وریبل اضافه میکنیم
          // حتما باید کلید
          //conditionFields:"yes"
          // باشه وگرنه کار نمیکنه
          variables={varRLookUp}



      />}
      <InsuranceInputHolder
        objectKey={objectKey}
        row={//
          {
            title: "مبلغ پیش پرداخت", type: 'price', name: 'prePayment', required: true,//
          }}
      />
      <InsuranceInputHolder
        objectKey={objectKey}
        row={//
          {
            title: "نوع دریافت پیش پرداخت",
            type: 'selectBox',
            name: 'receiveType',
            required: true,
            options: receiveTypeOptions
          }}
      />
      {myData.sendData[objectKey].receiveType === "نقدی" && <InsuranceInputHolder
        objectKey={objectKey}
        functionAfterSelect={afterRLookUpFound}
        row={//
          {
            title: "کد صندوق", name: 'fundId', type: 'rlookup', rlookupId: myData?.initialData?.fundRLookUpId,//
            required: false,//
          }}
      />}
      {myData.sendData[objectKey].receiveType === "واریز به حساب" && <InsuranceInputHolder
        objectKey={objectKey}
        functionAfterSelect={afterRLookUpBank}

        row={//
          {
            title: "کد بانک", name: 'bankId', type: 'rlookup', rlookupId: myData?.initialData?.bankRLookUpId,//
            required: false,//
          }}
      />}

      <InsuranceInputHolder
        objectKey={objectKey}
        row={//
          {title: "ارزش افزوده", type: 'price', name: 'addedValue', required: true,}}

      />
    </div>

  </div>);
}

export default FinancialInformation;